/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NewReassignmentDialog.vue?vue&type=template&id=1015f566"
import script from "./NewReassignmentDialog.vue?vue&type=script&lang=js"
export * from "./NewReassignmentDialog.vue?vue&type=script&lang=js"
import style0 from "./NewReassignmentDialog.vue?vue&type=style&index=0&id=1015f566&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1015f566')) {
      api.createRecord('1015f566', component.options)
    } else {
      api.reload('1015f566', component.options)
    }
    module.hot.accept("./NewReassignmentDialog.vue?vue&type=template&id=1015f566", function () {
      api.rerender('1015f566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/doctors/NewReassignmentDialog.vue"
export default component.exports